import { offset } from '@floating-ui/react';
export const useFloatingOffset = customOffset => {
  const offsetMiddleware = offset({
    mainAxis: customOffset[1],
    alignmentAxis: customOffset[0]
  });
  return {
    offsetMiddleware
  };
};